import React from 'react';
import {
  BrowserRouter,
  Route,
  Switch
} from 'react-router-dom';

import './style/App.css';

import Home from './Home';
import Privacy from './Privacy';

const App = () => (
  <BrowserRouter>

      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/privacy" component={Privacy} />
      </Switch>

  </BrowserRouter>

);

export default App;
